(function () {
  if (customElements.get("recently-viewed-products")) return;

  // Helper promise to resolve as soon as Splide assets load
  window.SplideLoaded =
    window.SplideLoaded ||
    new Promise((resolve) => {
      if (window.Splide) {
        resolve();
      } else {
        const script = document.querySelector('script[src*="splide.min.js"]');
        if (script) {
          script.addEventListener("load", () => resolve());
          script.addEventListener("readystatechange", () => {
            if (script.readyState === "complete" || script.readyState === "loaded") {
              resolve();
            }
          });
        } else {
          const interval = setInterval(() => {
            if (window.Splide) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        }
      }
    });

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    async init() {
      const currentProductHandle = this.dataset.productHandle;
      const limit = parseInt(this.dataset.productsToShow || '4', 10);
      const sectionId = this.dataset.sectionId;

      // Get recently viewed product handles from localStorage
      let recentlyViewed = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]');

      // Filter out current product if we are on a product page
      if (currentProductHandle) {
        recentlyViewed = recentlyViewed.filter(handle => handle !== currentProductHandle);
      }

      // If no recently viewed products, hide section
      if (recentlyViewed.length === 0) {
        // In theme editor design mode, we can show a mock/current product
        const isDesignMode = window.Shopify && window.Shopify.designMode;
        if (isDesignMode && currentProductHandle) {
          recentlyViewed = [currentProductHandle];
        } else {
          this.style.display = 'none';
          return;
        }
      }

      // Limit the number of handles to fetch
      const handlesToFetch = recentlyViewed.slice(0, limit);

      const listEl = this.querySelector('.splide__list');
      const containerEl = this.querySelector('.recently-viewed-products__container');
      if (!listEl || !containerEl) return;

      // Fetch product cards in parallel
      const fetchPromises = handlesToFetch.map(async (handle) => {
        try {
          const url = `/products/${handle}?sections=${sectionId}`;
          const response = await fetch(url);
          if (!response.ok) return null;
          const json = await response.json();
          const html = json[sectionId];
          if (!html) return null;

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const slide = doc.querySelector('.recently-viewed-product-card-holder li');
          return { handle, slide };
        } catch (e) {
          console.error(`Error fetching recently viewed product ${handle}:`, e);
          return null;
        }
      });

      const results = await Promise.all(fetchPromises);

      // Filter out nulls and keep the order of localStorage
      const validSlides = [];
      handlesToFetch.forEach(handle => {
        const match = results.find(res => res && res.handle === handle);
        if (match && match.slide) {
          validSlides.push(match.slide);
        }
      });

      if (validSlides.length === 0) {
        this.style.display = 'none';
        return;
      }

      // Append slides to the list
      listEl.innerHTML = '';
      validSlides.forEach(slide => {
        listEl.appendChild(slide);
      });

      // Show container
      containerEl.classList.remove('hidden');

      // Initialize Splide slider
      window.SplideLoaded.then(() => {
        const splideEl = this.querySelector('.splide');
        if (splideEl) {
          this.splide = new Splide(splideEl, {
            type: "slide",
            perPage: 5,
            perMove: 1,
            gap: "18px",
            arrows: false,
            pagination: true,
            drag: true,
            breakpoints: {
              1440: {
                gap: "10px",
              },
              1280: {
                perPage: 4,
                perMove: 1,
              },
              990: {
                perPage: 3,
                perMove: 1,
              },
              600: {
                perPage: 2,
              },
            },
          });
          this.splide.mount();
        }
      });
    }

    disconnectedCallback() {
      if (this.splide) {
        this.splide.destroy();
      }
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
})();
